import * as HLF from "html-living-framework";
import { TimelineMax, TweenLite } from 'gsap';
// @ts-ignore
import { PixiPlugin } from "gsap/PixiPlugin";
import { StoryLoadScreen } from "States/StoryLoadScreen"
import { Application } from "Singletons/Application";
import { Button } from "GameObjects/Button";
const dontTreeShakeMe = [PixiPlugin];

export class ChapterTitleScreen extends HLF.State {

	protected main = this.addChild(new PIXI.Container());

	protected bg = this.main.addChild(HLF.PixiUtils.makeSprite("title-bg"));
	protected image: PIXI.Sprite;
	protected _back: string[] = [];
    protected _subscriptions: any[] = [];
	protected _next: string;
	protected _alphaFilter?: PIXI.filters.AlphaFilter;
	protected isPreloading: boolean = false;
	protected stalled: boolean = false;
	protected playButton: Button;

	public constructor(pData: {
		image: string,
		next: string,
	}) {
		super();
		this.image = this.main.addChild(HLF.PixiUtils.makeSprite(pData.image));
		this.playButton = this.main.addChild(new Button(this.onPlayButtonClicked.bind(this), "play-button", undefined, undefined, undefined));
		this.main.scale.set(0.5);
		this.playButton.visible = false;
		this.playButton.y = 590;
		// this.image.alpha = 0;
		this._next = pData.next;
	}

	public onResize(pSize: PIXI.Point) {
		super.onResize(pSize);
	}

	public init(pSize: PIXI.Point, pData?: {name: string, back?: string[]}) {
		if (pData) {
			this.name = pData.name; // helps with debugging, also using it for back button functionality
			this._back = pData.back ?? [];
		}
		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: () => void) {
		if (this._alphaFilter === undefined) {
			this._alphaFilter = new PIXI.filters.AlphaFilter(0);
			this.filters = [this._alphaFilter];
		}
		const t = new TimelineMax();
		t.to(this._alphaFilter, 1, {alpha: 1})
		t.call(()=>{
			console.log(`begin hold on static screen ${this.name}`);
			console.time(`hold on static screen ${this.name}`);
			super.animateIn(()=>{
				pOnComplete();
				this.preloadNextState();
			});
		});
	}

	public animateOut(pOnComplete: () => void) {
		if (this._alphaFilter === undefined) {
			this._alphaFilter = new PIXI.filters.AlphaFilter(0);
			this.filters = [this._alphaFilter];
		}
		const t = new TimelineMax();
		t.to(this._alphaFilter, 1, {alpha: 0});
		t.call(()=>{
			super.animateOut(pOnComplete);
		});
	}

	public gotoNextState() {
        const steps = [
            HLF.TransitionStep.LoadAssets,
			HLF.TransitionStep.AttachNewBehind,
			HLF.TransitionStep.PauseAFrame,
			HLF.TransitionStep.AnimSimultaneously,
			HLF.TransitionStep.RemoveCurrent,
			HLF.TransitionStep.UnloadAssets,
        ];

		const go = ()=>{
			console.timeEnd(`hold on static screen ${this.name}`);
			PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
				{id: this._next, data: {
					name: this._next,
					back: [...this._back, this.name], // add this state to the history
				}}, StoryLoadScreen.NAME, ...steps)
			);
		}

		if (this.isPreloading) {
			HLF.LogUtils.logWarning("Transition stalled -- still preloading assets for %s", {className: this.name, color: HLF.LogUtils.COLOR_RELISH}, this._next);
			this.stalled = true;
		}
		else {
			go();
		}
	}

	public destroy(pDestroyOptions?: any) {
        super.destroy(pDestroyOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
    }

	protected onPlayButtonClicked() {
		this.playButton.hide(true, ()=>{
			this.gotoNextState();
		});
	}

	protected preloadNextState() {
		HLF.LogUtils.log("begin preloading assets for %s", {className: this.name, color: HLF.LogUtils.COLOR_LIGHT_BLUE}, this._next);
		this.isPreloading = true;
		console.time(`preload assets for ${this._next}`);
		PubSub.publishSync(HLF.LOAD_ASSETS, {assets: HLF.AssetMap.getAssetGroup(this._next), callback: ()=>{
			this.isPreloading = false;
			console.timeEnd(`preload assets for ${this._next}`);
			if (this.stalled) {
				this.gotoNextState();
			}
			else {
				console.log("show play button");
				this.playButton.show(true);
			}
			// HLF.LogUtils.log("finished preloading assets for %s", {className: this.name, color: HLF.LogUtils.COLOR_LIGHT_BLUE}, this._next);
		}});
	}

}
